import type { FC, ReactNode } from 'react';

import { Footer } from './styles';

const ProjectFooter: FC<{ children: ReactNode }> = ({ children }) => (
    <Footer direction="row" align="flex-start" gap={2}>
        {children}
    </Footer>
);

export default ProjectFooter;
